<template>
  <!-- <div id="upload"> -->
  <!-- action="https://jsonplaceholder.typicode.com/posts/" -->
  <!-- action="upload/" -->
  <!-- :on-change="uploadImage" -->
  <el-upload
    action="upload/"
    :show-file-list="!!0"
    list-type="picture-card"
    :on-progress="loadingProgress"
    :on-success="handleAvatarSuccess"
    :before-upload="handlePreview"
    :before-remove="handleRemove"
    :auto-upload="false"
    :on-change="uploadImage"
    class="upload-style"
  >
    <img v-if="imageUrl" :src="imageUrl" class="avatar" />
    <div v-else class="no-img">
      <i class="el-icon-plus">
        <br />
        <div class="tip">{{tipInfo1}}</div>
        <div class="tip">{{tipInfo2}}</div>
      </i>
    </div>
  </el-upload>
  <!-- </div> -->
</template>

<script>
import axios from "axios";
export default {
  name: "upload",
  data() {
    return {
      imageUrl: "",
      file: "",
      fileList: "",
      fileMD5: "",
    };
  },
  props: ['tipInfo1','tipInfo2'],
  mounted() {
    // console.log(this.tipInfo);
  },
  methods: {
    handleAvatarSuccess(res) {
      // console.log(res[0].url);
      this.imageUrl = res[0].url;
      this.$emit("upload-img", this.imageUrl);
      // this.imageUrl = URL.createObjectURL(file.raw);
      // this.file = file;
      // this.fileList = fileList;
      // // console.log(file);

      // this.$emit("upload-img", this.imageUrl, this.file.name, this.fileList);
      // ,this.file.raw
    },
    upload() {
      console.log(this.fileMD5);
    },

    uploadImage(file, fileList) {
      // console.log(file, fileList);

      this.convertImgToBase64(file.url, base64Img => {
        // console.log(base64Img);
        const randomNumber = this.randomWord(false, 32);
        return new Promise((resolve, reject) => {
          this.$http
            .post(
              "/upload/" + randomNumber + ".jpg",
              base64Img.substr(base64Img.indexOf(",") + 1, base64Img.length),
              {
                headers: { "Content-Type": "text/plain" }
              }
            )
            .then(response => {
              // console.log(response.data);
              // this.handleAvatarSuccess(response, file, fileList);
              this.handleAvatarSuccess(response.data.data);
              // resolve(response.data);
            })
            .catch(error => {
              reject(error);
            });
        });
      });
    },
    convertImgToBase64(url, callback, outputFormat) {
      var canvas = document.createElement("CANVAS"),
        ctx = canvas.getContext("2d"),
        img = new Image();
      img.crossOrigin = "Anonymous";
      img.onload = function() {
        canvas.height = img.height;
        canvas.width = img.width;
        ctx.drawImage(img, 0, 0);
        var dataURL = canvas.toDataURL(outputFormat || "image/png");
        callback.call(this, dataURL);
        canvas = null;
      };
      img.src = url;
    },
    handlePreview(file) {
      console.log(this.fileMD5, file);

      // return !!0;
    },
    handleRemove(file, fileList) {},
    loadingProgress(event) {
      // console.log(event.percent);
    },
    uploadFile(par) {
      console.log(par.file);
    },
    randomWord(randomFlag, min, max) {
      let str = "",
        range = min,
        arr = [
          "0",
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9",
          "a",
          "b",
          "c",
          "d",
          "e",
          "f",
          "g",
          "h",
          "i",
          "j",
          "k",
          "l",
          "m",
          "n",
          "o",
          "p",
          "q",
          "r",
          "s",
          "t",
          "u",
          "v",
          "w",
          "x",
          "y",
          "z"
        ];
      // 随机产生
      if (randomFlag) {
        range = Math.round(Math.random() * (max - min)) + min;
      }
      for (let i = 0; i < range; i++) {
        let pos = Math.round(Math.random() * (arr.length - 1));
        str += arr[pos];
      }
      return str;
    }
  }
};
</script>

<style lang='scss' scoped>
.avatar{
  border-radius: 6px;
}
.no-img {
  background-color: #393939 !important;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  .tip {
    width: 120px;
    margin-top: 10px;
    font-family: PingFangSC-Medium;
    font-size: 10px;
    color: #adadad;
    letter-spacing: 0.4px;
    text-align: center;
    word-wrap: break-word;
    word-break: break-all;
  }
}
</style>
